<template>
  <div class="nfc-tag-row">
    <div class="info">
      <p class="name">{{ tag.name }}</p>
      <p class="uid">{{ tag.uid }}</p>
      <p class="created-at">{{ formattedCreatedAt }}</p>
    </div>
    <div class="actions">
      <icon-button icon="el-icon-edit" @click="$emit('rename', tag)" />
      <icon-button icon="el-icon-delete" @click="confirmDelete" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NfcTagRow',
  props: {
    tag: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedCreatedAt () {
      if (!this.tag.createdAt) return ''
      const d = new Date(this.tag.createdAt)
      if (isNaN(d.getTime())) return this.tag.createdAt
      return d.toLocaleDateString()
    }
  },
  methods: {
    confirmDelete () {
      this.$confirm(`Remove tag ${this.tag.name}?`, 'Are you sure?', {
        confirmButtonText: 'Remove',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$emit('remove', this.tag.id)
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .nfc-tag-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 40px;
    border-bottom: 1px solid $border;

    &:last-child {
      border-bottom: none;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-right: 10px;

    .name {
      font-weight: 600;
      margin: 0 0 4px 0;
    }

    .uid {
      font-size: 12px;
      color: $text-light;
      margin: 0 0 2px 0;
      font-family: monospace;
    }

    .created-at {
      font-size: 11px;
      color: $text-light;
      margin: 0;
    }
  }

  .actions {
    display: flex;
    flex-shrink: 0;

    > * + * {
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/user/nfc-tags/NfcTagRow.vue